<template>
  <v-row>
    <v-col cols="12" md="6" lg="4">
      <v-card class="elevation-10">
        <v-card-title class="text-center">
          <v-spacer/>
          Контрагенты
          <v-spacer/>
        </v-card-title>
        <v-card-text>
          <div class="text-center">
            <v-icon size="64" color="primary">apartment</v-icon>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="blue darken-1" text :to="{name: 'directory-contractions'}">Открыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
    <v-col cols="12" md="6" lg="4">
      <v-card class="elevation-10">
        <v-card-title class="text-center">
          <v-spacer/>
          Товары
          <v-spacer/>
        </v-card-title>
        <v-card-text>
          <div class="text-center">
            <v-icon size="64" color="primary">flag</v-icon>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="blue darken-1" text :to="{name: 'directory-products'}">Открыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
    <v-col cols="12" md="6" lg="4">
      <v-card class="elevation-10">
        <v-card-title class="text-center">
          <v-spacer/>
          Доверенности
          <v-spacer/>
        </v-card-title>
        <v-card-text>
          <div class="text-center">
            <v-icon size="64" color="primary">{{mdiAccountMultipleCheck}}</v-icon>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="blue darken-1" text :to="{name: 'directory-attorneys'}">Открыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>

    <v-col cols="12" md="6" lg="4">
      <v-card class="elevation-10">
        <v-card-title class="text-center">
          <v-spacer/>
          Спецификация товаров
          <v-spacer/>
        </v-card-title>
        <v-card-text>
          <div class="text-center">
            <v-icon size="64" color="primary">{{mdiDivingScubaFlag}}</v-icon>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="blue darken-1" text :to="{name: 'directory-products-specification'}">Открыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>

</template>

<script>
import {mdiAccountMultipleCheck, mdiDivingScubaFlag} from "@mdi/js"

export default {
  name: "Directories",
  data() {
    return {
      mdiAccountMultipleCheck: mdiAccountMultipleCheck,
      mdiDivingScubaFlag: mdiDivingScubaFlag
    }
  }
}
</script>

<style scoped>

</style>